import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { ResetPasswordView } from '@/modules/auth'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/reset-password')({
  beforeLoad: ({ context }) => {
    if (context.authStore?.isAuthenticated) {
      throw redirect({
        to: '/',
        replace: true
      })
    }
  },
  validateSearch: z.object({
    redirect: z.string().catch('/check-email')
  }),
  component: ResetPasswordView,
  head: () =>
    getMetaWithPageTitle([i18n.t('title.reset-password', { ns: 'auth' })])
})
